.bt{justify-content:flex-end;}